import React, { ReactElement, useContext, MouseEvent, useMemo } from 'react';
import Dropdown, { IOption, PopoverPlacement } from 'shared/components/Dropdown';
import { FormsContext } from 'pages/Forms/context/FormsContext';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { HStack, Icon } from '@televet/kibble-ui';
import { FormQuestionType } from '@televet/shared-types';

const options: { text: string; value: FormQuestionType }[] = [
  {
    text: 'Text Input',
    value: FormQuestionType.TextInput,
  },
  {
    text: 'Multi Line Text Input',
    value: FormQuestionType.MultiLineTextInput,
  },
  {
    text: 'Multiple Selection',
    value: FormQuestionType.MultipleSelection,
  },
  {
    text: 'Drop Down',
    value: FormQuestionType.DropDown,
  },
  {
    text: 'Patient Picker',
    value: FormQuestionType.PetPicker,
  },
  {
    text: 'Checkbox',
    value: FormQuestionType.Checkbox,
  },
  {
    text: 'Date Input',
    value: FormQuestionType.DateInput,
  },
  {
    text: 'Time Input',
    value: FormQuestionType.TimeInput,
  },
  {
    text: 'Rating',
    value: FormQuestionType.RatingInput,
  },
  {
    text: 'Text Block',
    value: FormQuestionType.TextBlock,
  },
  {
    text: 'Signature Input',
    value: FormQuestionType.SignatureInput,
  },
];

interface Props {
  index: number;
  questionType: FormQuestionType;
}

const QuestionTitle = ({ index, questionType }: Props): ReactElement => {
  const { dispatch } = useContext(FormsContext);

  const onSelect = (e: MouseEvent, option: IOption): void => {
    dispatch({
      type: 'CHANGE_QUESTION_TYPE_AT_INDEX',
      payload: {
        questionIndex: index,
        questionType: option.value,
      },
    });
  };

  const currentValue = useMemo(() => {
    return options.find((o) => o.value === questionType);
  }, [questionType]);

  return (
    <div>
      <Dropdown options={options} placement={PopoverPlacement.BottomStart} onSelect={onSelect}>
        <HStack cursor="pointer" justify="baseline" spacing={1}>
          <Text fontWeight="bold" size="sm">
            {index + 1}. {currentValue?.text || ''}
          </Text>
          <Icon size="xs" name="chevronDown" />
        </HStack>
      </Dropdown>
    </div>
  );
};

export default QuestionTitle;
